<div *ngIf="group" class="field" [formGroup]="group">
  <ls-label-atom
    [text]="labelText"
    [forId]="labelFor"
    [class]="labelClass"
    [required]="required">
  </ls-label-atom>
  <ls-input-atom
    [inputId]="labelFor"
    [inputType]="inputType"
    [placeholder]="inputPlaceholder"
    [formControlName]="formName"
    [inputClass]="inputClass"
    [textError]="textError"
    [loading]="loading"
    [position]="position"
    [icon]="icon"
    [showIcon]="showIcon"
    [min]="min"
    [max]="max">
  </ls-input-atom>
</div>

<div *ngIf="!group" class="field">
  <ls-label-atom
    [text]="labelText"
    [forId]="labelFor"
    [class]="labelClass"
    [required]="required">
  </ls-label-atom>
  <ls-input-atom
    [inputId]="labelFor"
    [inputType]="inputType"
    [placeholder]="inputPlaceholder"
    [inputClass]="inputClass"
    [textError]="textError"
    [disabled]="disabled"
    [loading]="loading"
    [position]="position"
    [icon]="icon"
    [showIcon]="showIcon"
    [min]="min"
    [max]="max">
  </ls-input-atom>
</div>
